import { Link, Outlet, createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { q } from '../../api/queries';
import { useT } from '../../i18n';

export const Route = createFileRoute('/_app/projects/$projectId')({ component: ProjectLayout });

const tabs = [
  { to: '/projects/$projectId', label: 'rollout', exact: true },
  { to: '/projects/$projectId/policy', label: 'policy' },
  { to: '/projects/$projectId/graph', label: 'graph' },
  { to: '/projects/$projectId/modules', label: 'modules' },
  { to: '/projects/$projectId/decisions', label: 'decisions' },
] as const;

function ProjectLayout() {
  const t = useT();
  const { projectId } = Route.useParams();
  const projects = useQuery(q.projects());
  const project = projects.data?.items.find((p) => p.id === projectId);
  return (
    <div className="mx-auto w-full max-w-6xl">
      <p className="text-sm text-graphite"><Link to="/projects" className="hover:underline">{t.projects.title}</Link></p>
      <h1 className="mt-1 text-2xl font-semibold tracking-[-0.01em]">{project?.name ?? projectId}</h1>
      <nav aria-label={t.projects.cols.project} className="mt-4 mb-6 flex gap-5 border-b border-rule">
        {tabs.map((tab) => (
          <Link key={tab.to} to={tab.to} params={{ projectId }} activeOptions={{ exact: 'exact' in tab }}
            className="-mb-px border-b-2 border-transparent pb-2 text-graphite hover:text-ink data-[status=active]:border-ink data-[status=active]:font-medium data-[status=active]:text-ink">
            {t.projects.tabs[tab.label]}
          </Link>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
